(function(){
    'use strict';

    angular
       .module('appback')
       .factory('AnaliticasService', AnaliticasService);

       AnaliticasService.$inject = ['$http'];

   function AnaliticasService($http){

       var service= {
          getAnaliticasCategoria:getAnaliticasCategoria,
          getTiposAnalisis:getTiposAnalisis,
       };

       return service;

       function getAnaliticasCategoria(categoria,buscador,centro_sso,callback)
       {
           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }

           $http.get('/backend/cuentaapp/getanaliticascategoria', { params : {lang_id:lang_id,categoria : JSON.stringify(categoria),buscador:buscador, centro_sso:centro_sso }  }, config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }

       function getTiposAnalisis(callback)
       {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/cuentaapp/gettiposanalisis', { params : { }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
       }
   }
})();